import React from "react";
import PdfListPage from "./PdfListPage";
import { useRoe } from "./RoeLayout";

export default function ImportantLinks() {
  const data = useRoe();
  return (
    <PdfListPage
      eyebrow="Resources"
      title="Important Links"
      accent="teal"
      items={data.links || []}
      testid="roe-links"
      emptyMsg="No important links have been published yet."
    />
  );
}
